import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";

const Loading: React.FunctionComponent = () => {
  return (
    <Box textAlign="center">
      <Typography variant="h4" gutterBottom>
        Loading...
      </Typography>

      <Typography gutterBottom>Checking your Spotify session and current playback…</Typography>

      <CircularProgress size={30} />
    </Box>
  );
};

export default Loading;
